/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { Popover, requiredRule, useErrorState, ValidatedInput } from '@finbeat/react-toolkit';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { changeOtherPassword } from 'axios/userApi';
import useApi from 'hooks/useApi';
import { changePasswordErrorFormatter } from 'mappers/errorFormatters';
import { PasswordOtherChange } from 'models/api/users';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import 'scss/Main.scss';

type UserChangePasswordBtnProps = {
    id: string | number;
};

type PasswordOtherChangeProps = {
    newPassword: string;
    newPasswordConfirm: string;
};

const UserChangePasswordBtnForm = () => {
    const { t } = useTranslation();
    const { getValues } = useFormContext<PasswordOtherChangeProps>();

    return (
        <>
            <ValidatedInput<PasswordOtherChangeProps>
                id="info-password-field"
                type="password"
                name="newPassword"
                label={t('BackOfficePassword')}
                rules={{ required: requiredRule }}
            />
            <ValidatedInput<PasswordOtherChangeProps>
                id="info-password-confirm-field"
                type="password"
                name="newPasswordConfirm"
                label={t('BackOfficeConfirmPassword')}
                rules={{
                    required: requiredRule,
                    validate: (value) =>
                        value === getValues().newPassword || 'BackOfficePasswordConfirmMismatch',
                }}
            />
        </>
    );
};

export default function UserChangePasswordBtn({ id }: UserChangePasswordBtnProps) {
    const api = useApi();
    const { handleRequestError } = useErrorState();

    return (
        <Popover<PasswordOtherChangeProps>
            label={'change-status'}
            textStyle={'secondary'}
            buttonIcon={faLock}
            buttonLabel={'BackOfficeChangePassword'}
            mutationFunction={(data) => {
                const item: PasswordOtherChange = {
                    newPassword: data.newPassword,
                };

                return changeOtherPassword(api, id, item);
            }}
            defaultValues={{
                newPassword: '',
                newPasswordConfirm: '',
            }}
            onMutationError={(error: unknown): Promise<unknown> | void =>
                handleRequestError(
                    error,
                    'BackOfficeOopsSomethingWentWrong',
                    changePasswordErrorFormatter
                )
            }
            canSave={true}
            refetchQueryKeys={['users']}
            header={
                <>
                    <Trans i18nKey={'BackOfficeChangePassword'} />
                </>
            }
        >
            <UserChangePasswordBtnForm />
        </Popover>
    );
}
